export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AccordionList.vue?vue&type=template&id=56097b47&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionList.vue?vue&type=template&id=56097b47&scoped=true&
// module id = 422
// module chunks = 0